import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useScrollToTop from "../../../hooks/useScollToTop";
import ScrollIndicator from "../../Home/ScrollIndicator";
import DashboardNavigation from "../../DashboardNavigation/DashboardNavigation";
import HeaderTitle from "../../../components/HeaderTitle/HeaderTitle";

import { useBoutiqueDashboard } from "./hooks/useBoutiqueDashboard";

import BoutiqueHero from "./components/BoutiqueHero";
import BoutiqueToolbar from "./components/BoutiqueToolbar";
import BoutiqueArticleCard from "./components/BoutiqueArticleCard";
import BoutiqueArticleDrawer from "./components/BoutiqueArticleDrawer";
import CartDrawer from "./components/CartDrawer";
import BoutiqueSkeleton from "./components/BoutiqueSkeleton";
import BoutiqueEmptyState from "./components/BoutiqueEmptyState";
import { FaShoppingCart } from "react-icons/fa";

export default function Boutique() {
  useScrollToTop();

  const {
    user,
    userRole,

    articles,
    filteredArticles,
    visibleArticles,
    categories,
    loading,
    stats,

    ui,
    debouncedSearch,
    setDebouncedSearch,
    updateUi,
    resetFilters,
    loadMore,

    cart,
    setCart,
    cartOpen,
    openCart,
    closeCart,
    addToCart,
    removeFromCart,

    selectedArticle,
    articleDrawerOpen,
    openArticleDrawer,
    closeArticleDrawer,

    goToReglements,
    refresh,
  } = useBoutiqueDashboard();

  return (
    <section className="min-h-screen bg-slate-50 text-slate-950 dark:bg-slate-950 dark:text-white">
      <ScrollIndicator />

      <div className="pt-[96px] sm:pt-[120px] lg:pt-[160px]" aria-hidden />

      <main className="mx-auto w-full max-w-7xl px-3 pb-24 sm:px-6 lg:px-8">
        <HeaderTitle
          role="Utilisateur"
          title="Boutique en ligne"
          subtitle="Explore notre sélection d'articles et ajoute-les à ton panier pour un achat facile et rapide."
          icon={FaShoppingCart}
          align="left"
          className="mb-4"
        />

        <div className="mb-5 sm:mb-7">
          <DashboardNavigation role={userRole} />
        </div>

        <BoutiqueHero
          loading={loading}
          stats={stats}
          onRefresh={refresh}
          onOpenCart={openCart}
          onGoReglements={goToReglements}
        />

        <section className="mt-4 overflow-hidden rounded-[2rem] border border-white/70 bg-white/85 shadow-xl shadow-slate-200/70 backdrop-blur dark:border-slate-800/80 dark:bg-slate-900/70 dark:shadow-black/20 sm:mt-6">
          <div className="border-b border-slate-200/70 bg-white/70 px-3 py-3 dark:border-slate-800 dark:bg-slate-900/60 sm:px-5">
            <BoutiqueToolbar
              ui={ui}
              categories={categories}
              updateUi={updateUi}
              debouncedSearch={debouncedSearch}
              setDebouncedSearch={setDebouncedSearch}
              onReset={resetFilters}
              loading={loading}
              onRefresh={refresh}
              totalCount={articles.length}
              filteredCount={filteredArticles.length}
            />
          </div>

          <div className="p-3 sm:p-5 lg:p-6">
            {loading ? (
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
                {Array.from({ length: 6 }).map((_, index) => (
                  <BoutiqueSkeleton key={index} />
                ))}
              </div>
            ) : filteredArticles.length === 0 ? (
              <BoutiqueEmptyState onReset={resetFilters} />
            ) : (
              <>
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
                  {visibleArticles.map((article) => (
                    <BoutiqueArticleCard
                      key={article.id}
                      article={article}
                      onOpen={() => openArticleDrawer(article)}
                      onAdd={() => addToCart(article)}
                    />
                  ))}
                </div>

                {visibleArticles.length < filteredArticles.length && (
                  <div className="mt-6 flex justify-center">
                    <button
                      type="button"
                      onClick={loadMore}
                      className="inline-flex min-h-12 items-center justify-center rounded-2xl bg-[#013E8E] px-5 text-sm font-bold text-white shadow-lg shadow-blue-900/20 transition hover:-translate-y-0.5 hover:bg-indigo-800 hover:shadow-xl"
                    >
                      Charger plus
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </section>
      </main>

      <BoutiqueArticleDrawer
        isOpen={articleDrawerOpen}
        article={selectedArticle}
        onClose={closeArticleDrawer}
        onAdd={addToCart}
      />

      <CartDrawer
        isOpen={cartOpen}
        cart={cart}
        setCart={setCart}
        user={user}
        onClose={closeCart}
        onRemove={removeFromCart}
        onOrderSuccess={refresh}
        onGoReglements={goToReglements}
      />

      <ToastContainer />
    </section>
  );
}
